import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IModule, IRootScopeService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {gettextCatalog} from "angular-gettext";
import {MøteRessurs} from "felles/tjenester/ressurser/MøteRessurs";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {Debugger} from "debug";
import {MeldingTilBruker} from "../../../felles/tjenester/MeldingTilBruker";
import {MøtedeltakerRessurs} from "../../../felles/tjenester/ressurser/MøtedeltakerRessurs";
import {MøtedialogerForAjs} from "web/nedgraderteNg2Tjenester";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";

const debug: Debugger = require('debug')('MøteDeltakerTjeneste');

export class MøteDeltakerTjeneste {

    static regNavn = "wm.møte.MøteDeltakerTjeneste";

    static registrerTjenester(angular: IModule) {
        angular
            .service(MøteDeltakerTjeneste.regNavn, MøteDeltakerTjeneste.forInjisering());
    }

    static forInjisering() {
        return [
            regNavn.ng.$rootScope,
            MøtedeltakerRessurs.regNavn,
            MøteRessurs.regNavn,
            MeldingTilBruker.regNavn,
            ModelloppdateringTjeneste.regNavn,
            regNavn.gettext.gettextCatalog,
            ng2RegNavn.MøtedialogerForAjs,
            MøteDeltakerTjeneste
        ]
    }

    constructor(private $rootScope: IRootScopeService,
                private møtedeltakerRes: MøtedeltakerRessurs,
                private møteRes: MøteRessurs,
                private meldingTilBruker: MeldingTilBruker,
                private modelloppdatering: ModelloppdateringTjeneste,
                private gettextCatalog: gettextCatalog,
                private møtedialogerForAjs:MøtedialogerForAjs) {
    }

    /** @deprecated Bruk MøteDataTjeneste#godtaInnkalling */
    godtaInnkalling(møteId: string) {
        this.møtedeltakerRes.aksepterInnkalling(møteId).$promise
            .then(oppdatertDeltaker => this.innkallingOppdatert(oppdatertDeltaker.id, møteId));
    }

    /** @deprecated Bruk MøteDataTjeneste#avslåInnkalling */
    avslåInnkalling(møteId: string) {
        this.møtedeltakerRes.avslåInnkalling(møteId).$promise
            .then(oppdatertDeltaker => this.innkallingOppdatert(oppdatertDeltaker.id, møteId));
    }

    /** @deprecated Bruk MøteDataTjeneste#sendPurring */
    sendPurring(møteId: string) {
        this.møteRes.sendPurring(møteId).$promise.then(() =>
            /// kvittering for at møteinnkallingspurring har blitt sendt til møtedeltakere
            this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Påminnelse til deltakere som ikke har besvart innkalling, sendt.")))
    }

    sendInnkalling(møte: l.MøteModellEnkel, valgteDeltakere: l.GruppeMedlemListeModell[] = null) {
        this.møtedialogerForAjs.tjenestekallOmsluttetIAjsApplyAsync(this.$rootScope, tjeneste =>
          tjeneste.visSendInnkalling(møte.id, valgteDeltakere?.map(deltaker => deltaker.id) ?? null));
    }


    // private hjelpemetoder

    private innkallingOppdatert(oppdatertDeltakerId: string, møteId: string) {
        this.modelloppdatering.broadcastLokalMøtedeltakerOppdatert(oppdatertDeltakerId, møteId);
    }

}
